import { jwtDecode } from "jwt-decode";
const decodeHash = (hash: string): object | null => {
	if (!hash) throw new Error("hash is mandatory in decodeHash")
	const decoded: object | null = jwtDecode(hash)
	return decoded
}

export default decodeHash
